import React from "react";
import { Helmet } from "react-helmet-async";
const TermsOfUse = () => {
  return (
    <>
    <Helmet>
      <title>Terms Of Use | Reversethought</title>
      <meta name="description" content="Ensure clarity and protection with our comprehensive Terms of Use. Explore our expertly crafted terms and conditions to maintain a secure online presence." />      
      <link rel="canonical" href="https://www.reversethought.com/terms-of-use"/>
      <meta property="og:title" content="Terms Of Use | Reversethought" />
      <meta property="og:description" content="Ensure clarity and protection with our comprehensive Terms of Use. Explore our expertly crafted terms and conditions to maintain a secure online presence. "/>
      <meta property="og:url" content="https://reversethought.com/terms-of-use" />
      <meta name="twitter:title" content="Terms Of Use | Reversethought" />
      <meta name="twitter:description" content="Ensure clarity and protection with our comprehensive Terms of Use. Explore our expertly crafted terms and conditions to maintain a secure online presence." />

      <meta name="google-site-verification" content="HoCjksaLBwM7qPH8Nt-Rzrqa5K02wXYiJwFSEMC4j8g" />
      <meta name="p:domain_verify" content="f307b6f44d53f755ef67d9a9a3666de7" />
      <meta name="keywords" content="top social media marketing agencies in mumbai,best digital marketing company in mumbai,online lead generation companies,top creative agency india,creative agencies in mumbai,top digital agency in mumbai 2022,digital creative agency mumbai,digital creative agency india,digital agency mumbai,creative agency in mumbai,creative agency in india,design agency in mumbai" />        
      <meta name="generator" content="All in One SEO (AIOSEO) 4.4.7.1" />
      <meta property="og:site_name" content="Creative Agency In Mumbai | Branding Agency India - Reverse Thought" />
    </Helmet>
      <section
        className="bread bg-light py-5 "
        style={{ backgroundColor: "#f7f7f7" }}
      >
        <div className="container text-start">
          <h1
            className="text-dark"
            style={{ fontSize: "20px", lineHeight: "26px" }}
          >
            Terms of Use
          </h1>
        </div>
      </section>
      <section
        className="terms"
        style={{ padding: "90px 0 41px", minHeight: "70vh" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md12 col-xs-12">
              <div className="wpb_wrapper">
                <div className="last-paragraph-no-margin">
                  <p style={{ fontSize: "15px" }}>
                    PLEASE READ THESE WEBSITE TERMS OF USE CAREFULLY BEFORE
                    USING THIS WEBSITE (HEREINAFTER ‘WEBSITE’). THESE WEBSITE
                    TERMS OF USE (HEREINAFTER ‘TERMS OF USE’) GOVERN YOUR ACCESS
                    TO AND USE OF THE WEBSITE. THE WEBSITE IS AVAILABLE FOR YOUR
                    USE ONLY ON THE CONDITION THAT YOU AGREE TO THE TERMS OF USE
                    SET FORTH BELOW. IF YOU DO NOT AGREE TO ALL OF THE TERMS OF
                    USE, DO NOT ACCESS OR USE THE WEBSITE. BY ACCESSING OR USING
                    THE WEBSITE, YOU AND THE ENTITY YOU ARE AUTHORISED TO
                    REPRESENT (HEREINAFTER ‘YOU’ OR ‘YOUR’) SIGNIFY YOUR
                    AGREEMENT TO BE BOUND BY THE TERMS OF USE.
                  </p>
                  <p style={{ fontSize: "15px" }}>
                    <strong>User Eligibility</strong>
                    <br />
                    The Web Site is provided by REVERSE THOUGHT and available
                    only to entities and persons who have reached the age of
                    legal majority and are competent to enter into a legally
                    binding agreement(s) under the applicable law. If You do not
                    qualify, You are not permitted to use the Web Site.
                  </p>
                  <p style={{ fontSize: "15px" }}>
                    <strong>Scope Of Terms Of Use</strong>
                    <br />
                    These Terms of Use govern Your use of the Website and all
                    applications, software and services (collectively known as
                    “Services”) available via the Web Site, except to the extent
                    that such Services are the subject of a separate agreement.
                    Specific terms or agreements may apply to the use of certain
                    Services and other items provided to You via the Web Site
                    (“Service Agreement(s)”). Any such Service Agreements will
                    accompany the applicable Services or are listed in
                    association therewith or via a hyperlink associated
                    therewith.
                  </p>
                  <p style={{ fontSize: "15px" }}>
                    <strong>Modifications</strong>
                    <br />
                    REVERSE THOUGHT may revise and update these Terms of Use at
                    any time. Your continued usage of the Web Site after any
                    changes to these Terms of Use will be deemed as acceptance
                    of such changes. Any aspect of the Web Site may be changed,
                    supplemented, deleted or updated without notice, at the sole
                    discretion of REVERSE THOUGHT. REVERSE THOUGHT may also
                    change or impose fees for products and services provided
                    through the Web Site at any time, at its sole discretion.
                    REVERSE THOUGHT may establish or change, at any time,
                    general practices and restrictions concerning other REVERSE
                    THOUGHT products and services at its sole discretion.
                  </p>
                  <p style={{ fontSize: "15px" }}>
                    <strong>REVERSE THOUGHT Privacy Notice</strong>
                    <br />
                    With respect to any individual whose personal information is
                    provided by You to REVERSE THOUGHT, You represent to REVERSE
                    THOUGHT that You have obtained all necessary consents for
                    the processing of such personal information contemplated by
                    the Services.
                  </p>
                  <p style={{ fontSize: "15px" }}>
                    <strong>Licence and Ownership</strong>
                    <br />
                    Any and all intellectual property rights (“Intellectual
                    Property”) associated with the Web Site and its contents
                    (the “Content”) are the sole property of REVERSE THOUGHT,
                    its affiliates or third parties. The Content is protected by
                    Intellectual Property and other laws both in India and other
                    countries. Elements of the Web Site are also protected by
                    trade name, trade secret, unfair competition, and other laws
                    and may not be copied or imitated in whole or in part. All
                    customised graphics, icons, and other items that appear on
                    the Web Site are trademarks, service marks or trade name
                    (“Marks”) of REVERSE THOUGHT, its affiliates or other
                    entities that have granted REVERSE THOUGHT the right and
                    licence to use such Marks and may not be used or interfered
                    with in any manner without the express written consent of
                    REVERSE THOUGHT. Except as otherwise expressly authorised by
                    these Terms of Use, You may not copy, reproduce, modify,
                    amend, lease, loan, sell and/or create derivative works
                    from, upload, transmit, and/or distribute the Intellectual
                    Property of the Web Site in any way without REVERSE
                    THOUGHT’s prior written permission or that of an appropriate
                    third party. Except as expressly provided herein, REVERSE
                    THOUGHT does not grant to You any express or implied rights
                    to the Intellectual Property of REVERSE THOUGHT or that of
                    any third party.
                  </p>
                  <p style={{ fontSize: "15px" }}>
                    REVERSE THOUGHT hereby grants You a limited, personal,
                    non-transferable, non-sublicensable, revocable licence to
                    (a) access and use only the Web Site, Content and Services
                    only in the manner presented by REVERSE THOUGHT, and (b)
                    access and use the REVERSE THOUGHT computer and network
                    services offered within the Web Site (the “REVERSE THOUGHT
                    Systems”) only in the manner expressly permitted by REVERSE
                    THOUGHT. Except for this limited license, REVERSE THOUGHT
                    does not convey any interest in or to the REVERSE THOUGHT
                    Systems, information or data available via the REVERSE
                    THOUGHT Systems (the “Information”), Content, Services, Web
                    Site or any other REVERSE THOUGHT property by permitting You
                    to access the Web Site. Except to the extent required by law
                    or as expressly provided herein, none of the Content and/or
                    Information may be reverse-engineered, modified, amended,
                    reproduced, republished, translated into any language or
                    computer language, re-transmitted in any form or by any
                    means, resold or redistributed without the prior written
                    consent of REVERSE THOUGHT. You may not make, sell, offer
                    for sale, modify, amend, reproduce, display, publicly
                    perform, import, distribute, retransmit or otherwise use the
                    Content in any way unless expressly permitted to do so by
                    REVERSE THOUGHT.
                  </p>
                  <p style={{ fontSize: "15px" }}>
                    <strong>Restrictions on Use Of The Website</strong>
                    <br />
                    In addition to other restrictions set forth in these Terms
                    of Use, You agree that:
                  </p>
                  <ul
                    style={{
                      marginTop: 0,
                      marginBottom: "1rem",
                      listStyle: "disc",
                    }}
                  >
                    <li
                      style={{
                        display: "list-item",
                        textAlign: "-webkit-match-parent",
                      }}
                    >
                      You shall not disguise the origin of information
                      transmitted through the Web Site.
                    </li>
                    <li
                      style={{
                        display: "list-item",
                        textAlign: "-webkit-match-parent",
                      }}
                    >
                      You will not place false or misleading information on the
                      Web Site.
                    </li>
                    <li
                      style={{
                        display: "list-item",
                        textAlign: "-webkit-match-parent",
                      }}
                    >
                      You will not use or access any service, information,
                      application or software available via the Web Site in a
                      manner not expressly permitted by REVERSE THOUGHT.
                    </li>
                    <li
                      style={{
                        display: "list-item",
                        textAlign: "-webkit-match-parent",
                      }}
                    >
                      You will not input or upload to the Web Site any
                      information that may contain viruses, Trojan horses,
                      worms, time bombs or other computer programming routines
                      that are intended to damage, interfere with, intercept or
                      expropriate any system, the Web Site or Information or
                      that infringes the Intellectual Property rights of
                      another.
                    </li>
                    <li
                      style={{
                        display: "list-item",
                        textAlign: "-webkit-match-parent",
                      }}
                    >
                      Certain areas of the Web Site are restricted to customers
                      of REVERSE THOUGHT.
                    </li>
                    <li
                      style={{
                        display: "list-item",
                        textAlign: "-webkit-match-parent",
                      }}
                    >
                      You may not use or access the Web Site or the REVERSE
                      THOUGHT Systems or Services in any way that, in REVERSE
                      THOUGHT’s judgment, adversely affects the performance or
                      function of the REVERSE THOUGHT Systems, Services or the
                      Web Site or interferes with the ability of authorised
                      parties to access the REVERSE THOUGHT Systems, Services or
                      the Web Site.
                    </li>
                    <li
                      style={{
                        display: "list-item",
                        textAlign: "-webkit-match-parent",
                      }}
                    >
                      You may not frame or utilize framing techniques to enclose
                      any portion or aspect of the Content or the Information,
                      without the express written consent of REVERSE THOUGHT.
                    </li>
                  </ul>
                  <p style={{ fontSize: "15px" }}>&nbsp;</p>
                  <p style={{ fontSize: "15px" }}>
                    <strong>Links</strong>
                    <br />
                    Outbound Links. The Web Site may contain links to
                    third-party Web Sites and resources (referred to
                    collectively hereinafter as “Linked Sites”). These Linked
                    Sites are provided solely as a convenience to You and not as
                    an endorsement by REVERSE THOUGHT of the content of such
                    Linked Sites. REVERSE THOUGHT makes no representations or
                    warranties regarding the correctness, accuracy, performance
                    or quality of any content, software, service or application
                    found at any Linked Site. REVERSE THOUGHT shall not be
                    responsible for the availability of the Linked Sites or the
                    content or activities of such sites. If You decide to access
                    Linked Sites, You do so at Your own risk. In addition, Your
                    use of Linked Sites is subject to any applicable policies
                    and terms and conditions of use, including but not limited
                    to, the Linked Site’s privacy policy.
                  </p>
                  <p style={{ fontSize: "15px" }}>
                    Inbound Links. Linking to any page of the Web Site other
                    than to https://www.REVERSE THOUGHT.com through a plain text
                    link is strictly prohibited in the absence of a separate
                    linkage agreement with REVERSE THOUGHT. Any website or other
                    devices that link to https://www.REVERSE THOUGHT.com or any
                    page available therein is prohibited from
                  </p>
                  <ul>
                    <li
                      style={{
                        display: "list-item",
                        textAlign: "-webkit-match-parent",
                      }}
                    >
                      replicating Content,
                    </li>
                    <li
                      style={{
                        display: "list-item",
                        textAlign: "-webkit-match-parent",
                      }}
                    >
                      using a browser or border environment around the Content,
                    </li>
                    <li
                      style={{
                        display: "list-item",
                        textAlign: "-webkit-match-parent",
                      }}
                    >
                      implying in any fashion that REVERSE THOUGHT or any of its
                      affiliates endorse it or its products,
                    </li>
                    <li
                      style={{
                        display: "list-item",
                        textAlign: "-webkit-match-parent",
                      }}
                    >
                      misrepresenting any state of facts, including its
                      relationship with REVERSE THOUGHT or any of the REVERSE
                      THOUGHT affiliates,
                    </li>
                    <li
                      style={{
                        display: "list-item",
                        textAlign: "-webkit-match-parent",
                      }}
                    >
                      presenting false information about REVERSE THOUGHT
                      products or services, and
                    </li>
                    <li
                      style={{
                        display: "list-item",
                        textAlign: "-webkit-match-parent",
                      }}
                    >
                      using any logo or mark of REVERSE THOUGHT or any of its
                      affiliates, without express written permission from
                      REVERSE THOUGHT
                    </li>
                  </ul>
                  <p style={{ fontSize: "15px" }}>&nbsp;</p>
                  <p style={{ fontSize: "15px" }}>
                    <strong>Termination</strong>
                    <br />
                    You agree that REVERSE THOUGHT, at its sole discretion, may
                    terminate or suspend Your use of the Web Site, the REVERSE
                    THOUGHT Systems, Information, Services and Content at any
                    time and for any or no reason at its sole discretion, even
                    if access and use continue to be allowed to others. Upon
                    such suspension or termination, You must immediately
                  </p>
                  <ul>
                    <li
                      style={{
                        display: "list-item",
                        textAlign: "-webkit-match-parent",
                      }}
                    >
                      discontinue Your use of the Web Site, and
                    </li>
                    <li
                      style={{
                        display: "list-item",
                        textAlign: "-webkit-match-parent",
                      }}
                    >
                      destroy any copies You may have made of any portion of the
                      Content. Accessing the Web Site, the REVERSE THOUGHT
                      Systems, Information or Services after such termination,
                      suspension or discontinuation shall constitute an act of
                      trespass. Furthermore, You agree that REVERSE THOUGHT
                      shall not be liable to You or to any third party for any
                      termination or suspension of Your access to the Web Site,
                      the REVERSE THOUGHT Systems, Information and/or the
                      Services.
                    </li>
                  </ul>
                  <p style={{ fontSize: "15px" }}>&nbsp;</p>
                  <p style={{ fontSize: "15px" }}>
                    <strong>Disclaimer of Warranties</strong>
                    <br />
                    REVERSE THOUGHT MAKES NO REPRESENTATIONS ABOUT THE RESULTS
                    TO BE OBTAINED FROM USING THE WEBSITE, THE REVERSE THOUGHT
                    SYSTEMS, THE SERVICES, THE INFORMATION OR THE CONTENT. THE
                    USE OF SAME IS AT YOUR OWN RISK. THE WEBSITE, THE REVERSE
                    THOUGHT SYSTEMS, THE INFORMATION, THE SERVICES AND THE
                    CONTENT ARE PROVIDED ON AN “AS IS” BASIS. REVERSE THOUGHT,
                    ITS LICENSORS, AND ITS SUPPLIERS, TO THE FULLEST EXTENT
                    PERMITTED BY LAW, DISCLAIM ALL WARRANTIES, EITHER EXPRESS OR
                    IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED
                    TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY,
                    NON-INFRINGEMENT OF THIRD PARTY RIGHTS, AND FITNESS FOR A
                    PARTICULAR PURPOSE. REVERSE THOUGHT AND ITS AFFILIATES,
                    LICENSORS AND SUPPLIERS MAKE NO REPRESENTATIONS OR
                    WARRANTIES CONCERNING THE ACCURACY, COMPLETENESS, SECURITY
                    OR TIMELINESS OF THE CONTENT, INFORMATION OR SERVICES
                    PROVIDED ON OR THROUGH THE USE OF THE WEB SITE OR THE
                    REVERSE THOUGHT SYSTEMS. NO INFORMATION OBTAINED BY YOU FROM
                    THE WEBSITE SHALL CREATE ANY WARRANTY NOT EXPRESSLY STATED
                    BY REVERSE THOUGHT IN THESE TERMS OF USE.
                  </p>
                  <p style={{ fontSize: "15px" }}>
                    <strong>Limitation of Liability</strong>
                    <br />
                    TO THE EXTENT PERMITTED BY APPLICABLE LAW AND TO THE EXTENT
                    THAT REVERSE THOUGHT IS OTHERWISE FOUND TO BE RESPONSIBLE
                    FOR ANY DAMAGES, REVERSE THOUGHT SHALL BE RESPONSIBLE FOR
                    ACTUAL DAMAGES ONLY. TO THE EXTENT PERMITTED BY LAW, IN NO
                    EVENT SHALL REVERSE THOUGHT, ITS AFFILIATES, LICENSORS,
                    SUPPLIERS OR ANY THIRD PARTIES MENTIONED AT THE WEB SITE BE
                    LIABLE FOR ANY INCIDENTAL, INDIRECT, EXEMPLARY, PUNITIVE
                    AND/OR CONSEQUENTIAL DAMAGES, LOST PROFITS, AND/OR DAMAGES
                    RESULTING FROM LOST DATA OR BUSINESS INTERRUPTION RESULTING
                    FROM THE USE OF AND/OR INABILITY TO USE THE WEBSITE, THE
                    REVERSE THOUGHT SYSTEMS, INFORMATION, SERVICES OR THE
                    CONTENT WHETHER BASED ON WARRANTY, CONTRACT, TORT, DELICT,
                    OR ANY OTHER LEGAL FOUNDATION, AND WHETHER OR NOT REVERSE
                    THOUGHT IS ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. TO
                    THE EXTENT PERMITTED BY LAW, THE REMEDIES STATED FOR YOU IN
                    THESE TERMS OF USE ARE EXCLUSIVE AND ARE LIMITED TO THOSE
                    EXPRESSLY PROVIDED FOR HEREIN.
                  </p>
                  <p style={{ fontSize: "15px" }}>
                    <strong>
                      Compliance With Law including Export Control
                    </strong>
                    <br />
                    You agree to use the Web Site in strict compliance with all
                    applicable laws, rulings, and regulations and in a fashion
                    that does not, in the sole judgment of REVERSE THOUGHT,
                    negatively reflect on the goodwill or reputation of REVERSE
                    THOUGHT and You shall take no action which might cause
                    REVERSE THOUGHT to be in breach of any laws, rulings or
                    regulations applicable to REVERSE THOUGHT.
                  </p>
                  <p style={{ fontSize: "15px" }}>
                    REVERSE THOUGHT and the Web Site are based in India. India,
                    the United States and certain other jurisdictions control
                    the export of products and information. You agree to comply
                    with all such applicable restrictions and not to export or
                    re-export the Content (including any software or the
                    Services) to countries or persons prohibited under India or
                    other applicable export control laws or regulations. If You
                    access and download the Content (including any software or
                    the Services) or Information, You represent that You are not
                    in a country where such export is prohibited or are not a
                    person or entity to which such export is prohibited. You are
                    solely responsible for compliance with the laws of Your
                    local jurisdiction and any other applicable laws regarding
                    the import, export, or re-export of the Content (including
                    any software or the Services).
                  </p>
                  <p style={{ fontSize: "15px" }}>
                    <strong>Governing Law and Jurisdiction</strong>
                    <br />
                    To the fullest extent permitted by law, these Terms of Use
                    are governed by the internal laws of India and courts in
                    Mumbai, India will have jurisdiction.
                  </p>
                  <p style={{ fontSize: "15px" }}>
                    <strong>General</strong>
                    <br />
                    You may not assign these Terms of Use or any of Your
                    interests, rights or obligations under these Terms of Use.
                    If any provision of these Terms of Use shall be found to be
                    invalid by any court having competent jurisdiction, the
                    invalidity of such provision shall not affect the validity
                    of the remaining provisions of these Terms of Use, which
                    shall remain in full force and effect. No waiver of any of
                    these Terms of Use shall be deemed a further or continuing
                    waiver of such term or condition or any other term or
                    condition. You may preserve these Terms of Use in written
                    form by printing them for Your records, and You waive any
                    other requirement for these Terms of Use to be proved by
                    means of a written document.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsOfUse;
